import { ReactNode } from 'react';
import { usePageTitle } from '@/creditflowresearch/ui/common/hooks/title/usePageTitle';

interface IUseProductPageTitleOptions {
  title: string | ReactNode,
  productAbbreviations: string[],
  shouldShowLock: boolean,
}

export const useProductPageTitle = ({
  title,
  productAbbreviations,
  shouldShowLock,
}: IUseProductPageTitleOptions): ReactNode => {
  return usePageTitle({
    title,
    productAbbreviations,
    shouldShowLock,
  });
};
